import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, Button } from "@material-ui/core";

import { hasItems, leavingSiteFrom, pay } from "util/APIUtils";
import Invoice from "./Invoice";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 500,
    margin: "auto",
    textAlign: "left",
  },
  buttons: {
    textAlign: "center",
    padding: "1em 0",
  },
}));

export default function Checkout({
  order,
  error: passedError,
  user,
  initiatingBrand,
  updateInvoice: passedUpdateInvoice,
  enqueueSnackbar,
  children: buttons,
}) {
  const history = useHistory();
  const { location } = history;
  const [error, setError] = useState(passedError);
  const classes = useStyles();
  const noOrder = hasItems(order);
  const paid = order && order.receiptPresented;
  const nextStepLabel = paid ? "Show me my Brands" : "Proceed to pay";
  const continueToPay = () => {
    setError(null);
    if (user) {
      pay(user.id)
        .then(({ token, checkoutUrl }) => {
          leavingSiteFrom(location, { order: order });
          window.location.href = checkoutUrl;
        })
        .catch((response) => {
          setError(
            response.message || "There was a problem transitioning to pay."
          );
        });
    } else {
      setError(
        "A user must be supplied to this component if no controlling parent component"
      );
    }
  };
  const updateInvoice = () => {
    setError(null);
    passedUpdateInvoice();
  };

  const continueToNextStep = () => {
    if (paid) {
      goToMyBrands();
    } else {
      continueToPay();
    }
  };

  const goToMyBrands = () => history.push("/my-brands");

  return (
    <div className={classes.root}>
      {error && <div className="error">{error}</div>}
      {order ? (
        <Invoice
          paid={order.receiptPresented}
          initiatingBrand={initiatingBrand}
          order={order}
          updateInvoice={updateInvoice}
          enqueueSnackbar={enqueueSnackbar}
        />
      ) : (
        <span>Order not found</span>
      )}
      {buttons ? (
        buttons
      ) : (
        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            disabled={noOrder}
            onClick={() => continueToNextStep()}
          >
            {nextStepLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
